export enum PropertyStage {
  ComingSoon = 'ComingSoon',
  UpComing = 'UpComing',
  Live = 'Live',
  PreLaunch = 'PreLaunch',
  FullFunded = 'FullFunded',
  ReSale = 'ReSale',
}
